import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon, StyledIconVariants } from '../SMPIcon';

type SMPDrawIconProps = StyledIconVariants & {
  onClick?: () => void;
  css?: CSS;
};

export const SMPDrawIcon = (props: SMPDrawIconProps): JSX.Element => {
  return (
    <SMPIcon {...props}>
      <defs>
        <pattern id='draw' preserveAspectRatio='xMidYMid slice' width='100%' height='100%' viewBox='0 0 67 67'>
          <image
            width='67'
            height='67'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAYAAADHyrhzAAAACXBIWXMAAC4jAAAuIwF4pT92AAADoUlEQVR4nO2cMVLbQBSGPzSENk4yk0k65wR4MpMiVcwJMK0alkYt+ATACQytUlg0SomZSZMig3KCKDdQl0wq5QYpdmXLRrYle6WVZX8zDFislsevt29Xq/e0R0W4nt8G2kAXeA505jSNgV/qe+gIOyjfOsleWR27nt8CesAnpADtNboLgQB4KFMc7WK4nt8DTpFClEEMeMCtI+xIZ8faxHA9XwCXrOcBRRkhRQl0dLa2GMoTBlQrwiwjoL+up6wshgqIQ2Q8qAvXjrCvVj15JTGUNwyB1qp/uERC4GQVL7GKnuB6/hC4p55CgJyyf6oLVojcnqGmynvqNSyW0XeEfZO3cS4xlBCPzF8o1RnPEfZZnoZLxdhwIRJyCbIwZjRECADhev7FskbLAuiAzRciYbAsqM4VQykpdFtkmKHr+XMvbqYY6oRBaSaZo4VcH2UyzzPmntAAOq7nX2X94slsooZHE71ilnezq9Qpz1Czx2WVFhnkyQWfHSYX1HeZrZue6/nd9IGxGMorzqu2yDBT/2/aM7bJKxJ6aisCmBbjtHpbasHYOywANXbahowxzXhVmnjGtnoFQDsJpIkYXWOm1INjACv1cGeb6YL0jK5RM+pBB6QYh4YNqQWu53ctmrNfsS6dfTTHi1cvX/Dxw3udXWby9dt33V22tItxcPCMt29e6+yyKg4LPzdpMK2dGCl2YqTYiZFiJ0aKnRgpdmJMCPeRiWNdXT3+/vOXz3dfdHVXJf8sIDJtRU0ILGTO5Q6ILGTaz7YTOcKOLJU2GJu2xjABTGaTwJgZ9eAHTMR4MGhIHRjBRIwR2ztURo6wY1BiqA8joyaZ4y75Ib0CvTVgiGkiR9hjJxiL4Qg7KWPYJq7TH2bvTa7ZHiJH2F76wJQYas0x1aDB9GcPZN219mn+zBKkY0XCEzHUzNLk4RIDmdnCmfsZKvm8qVPt2bzyi0WbO2c07ybuJmt4JCxMpFfJsY80I70pcIR9tKjBwm0/tfY4YvMDagicLGuUt95kkz0kBI6S+49FFKlE2kRBcgsBBQv2lCBDNiONIXcFUkKhRwWpGFL3abdfVAhYr65VIPOv6zRsQuQ6YqUlwVoVzyrFeoD5Ip0YWeCbu1IxCy218CqP8pLqk+Vi5D7MTd4guQitb0lQAfYcmXVb5vCJkDtUWkRIKOX9Gal3ZxwjvUWHMBEycJf2Do3SXiaSRg2jDjLNss3y4RSprxD5xC/Q/a6MLP4DC3b6mwiWcQoAAAAASUVORK5CYII='
          />
        </pattern>
      </defs>
      <path fill='url(#draw)' d='M0 0h16v16H0z' />
    </SMPIcon>
  );
};
